import { SelectChangeEvent } from "@mui/material";
import {
  AudioFileTrackProperties,
  InstrumentTrackProperties,
} from "../../../pages/DAW/types";

export interface Props {
  trackProperties: InstrumentTrackProperties | AudioFileTrackProperties
  handleNameChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  handlePanChange: (newValue: number) => void
  handleMuteChange: () => void
  handleSoloChange: () => void
  handleVolumeChange: (newValue: number) => void
  handleRemoveTrack: (id: number) => void
  handleInstrumentTypeChange?: (event: SelectChangeEvent<string>) => void
  handleEffectChange?: (event: SelectChangeEvent<string>) => void
  onNameFieldFocusChange: (blur: boolean) => void
}

export const INSTRUMENT_TYPES = [
  "amSynth",
  "duoSynth",
  "fmSynth",
  "membraneSynth",
  "metalSynth",
  "monoSynth",
  "pluckSynth",
  "synth",
  "sampler",
];

export const EFFECTS = [
  "autoFilter",
  "autoPanner",
  "autoWah",
  "bitCrusher",
  "distortion",
  "feedbackDelay",
  "freeverb",
  "panVol",
  "tremolo",
];
